import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import withdrawalForm from "../../assets/Template - Savings Tracker Withdrawal Email.pdf";
import Screen from "../shared/screen";
import "./style.css";
import { axiosInstance } from "../../config/apiTemplate";
import Skeleton from "@mui/material/Skeleton";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { stripCommaToNum } from "../shared/util";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import Button from "@mui/material/Button";
import { EtTable } from "../shared/table/table";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridOverlay,
} from "@mui/x-data-grid-pro";
import LinearProgress from "@mui/material/LinearProgress";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";

am4core.useTheme(am4themes_animated);

function SavingsPage() {
  const cashRatioChart = useRef(null);
  const navChart = useRef(null);
  const [toggles, setToggle] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [isLoading, setLoading] = useState(true);
  const [portfolio, setPortfolio] = useState(localStorage.getItem("t_id"));
  const [dashboard, setDashboard] = useState({
    top_shareholdings: [],
    latest_trades: [],
    latest_dividends: [],
    chart_data: [],
    portfolio_cash_ratio: { cash: 10, stocks: 100 },
    daily_change: {
      klci_change_perc: 0,
      portfolio_change: 0,
      portfolio_change_perc: 0,
      today_value: 0,
      yesterday_value: 0,
    },
  });
  const [aggregatedData, setAggregatedData] = useState({
    initialTpv: 0,
    currentTpv: 0,
    abs_return: 0,
    abs_return_percentage: 0,
    aggregatedTPV: [],
    unconfirmed_deposit: 0,
  });
  const [deposits, setDeposits] = useState("0");
  const [cashBalance, setCashBalance] = useState("0");
  const [mmInterest, setMmInterest] = useState("0");
  const [floatingBalance, setFloatingBalance] = useState("0");
  const [mmInterestLogs, setMmInterestLogs] = useState([]);
  const [strategies, setStrategies] = useState([]);
  const [withdrawalRequests, setWithdrawalRequests] = useState([]);
  const [withdrawalBalance, setWithdrawalBalance] = useState({
    cash_balance: "0",
    net_cash_balance: "0",
    cash_balance_raw: 0,
    is_corporate: false,
    bank_accounts: [],
    market_rep: [],
  });
  const [withdrawModalOpen, setWithdrawModalOpen] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [withdrawError, setWithdrawError] = useState("");
  const [status, setStatus] = useState({
    boi_summary: [],
  });
  let [tabIndex, setTabIndex] = useState(0);
  let productView = localStorage.getItem("productView");
  let client_code = localStorage.getItem("clientCode");

  useEffect(() => {
    document.title = "ETSW - Portfolio Dashboard";

    // Sleep 1 second
    setTimeout(() => {
      // getDashboardData();
      // getAggregatedData();
      // getStatus();
      getStats();
      getWithdrawalRequests();
      getWithdrawalBalance();
    }, 1000);

    // getDashboardData();
    // getAggregatedData();
  }, []);

  //  API ========================================================================================================================

  async function getStats() {
    const url = "client_api/savings/getStats_v2.php";

    let statsForm = new FormData();
    statsForm.append("client_code", client_code);

    try {
      const response = await axiosInstance.post(url, statsForm);
      if (response.data.status === 201) {
        setDeposits(response.data.deposits);
        setCashBalance(response.data.cash_balance);
        setMmInterest(response.data.mm_interest);
        setMmInterestLogs(response.data.mm_interest_logs);
        setStrategies(response.data.strategies);
        setFloatingBalance(response.data.pending_approval);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function getWithdrawalRequests() {
    const url = "client_api/savings/getWithdrawalRequests.php";

    let withdrawalRequestsForm = new FormData();
    withdrawalRequestsForm.append("client_code", client_code);

    try {
      const response = await axiosInstance.post(url, withdrawalRequestsForm);
      if (response.data.status === 201) {
        setWithdrawalRequests(response.data.withdrawal_requests);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function getWithdrawalBalance() {
    const url = "client_api/savings/getWithdrawalBalance.php";

    let withdrawalBalanceForm = new FormData();
    withdrawalBalanceForm.append("client_code", client_code);

    try {
      const response = await axiosInstance.post(url, withdrawalBalanceForm);
      if (response.data.status === 201) {
        setWithdrawalBalance({
          cash_balance: response.data.cash_balance,
          net_cash_balance: response.data.net_cash_balance,
          cash_balance_raw: parseFloat(
            String(response.data.net_cash_clean).replace(/,/g, ""),
          ),
          is_corporate: response.data.is_corporate,
          bank_accounts: response.data.bank_accounts ?? [],
          market_rep: response.data.market_rep ?? [],
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function submitWithdrawalRequest(amount) {
    const url = "client_api/savings/submitWithdrawalRequest.php";

    const bankAccount = withdrawalBalance.bank_accounts[0];
    let submitWithdrawalRequestForm = new FormData();
    submitWithdrawalRequestForm.append("client_code", client_code);
    submitWithdrawalRequestForm.append("amount", amount);
    submitWithdrawalRequestForm.append(
      "bank_name",
      bankAccount?.bank_name ?? "",
    );
    submitWithdrawalRequestForm.append(
      "account_number",
      bankAccount?.account_number ?? "",
    );

    try {
      const response = await axiosInstance.post(
        url,
        submitWithdrawalRequestForm,
      );
      if (response.data.status === 201) {
        window.alert("Withdrawal request submitted successfully");
        getWithdrawalRequests();
        getWithdrawalBalance();
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function deleteWithdrawalRequest(id) {
    const url = "client_api/savings/deleteWithdrawalRequest.php";
    let deleteWithdrawalRequestForm = new FormData();
    deleteWithdrawalRequestForm.append("id", id);
    deleteWithdrawalRequestForm.append("client_code", client_code);
    try {
      const response = await axiosInstance.post(
        url,
        deleteWithdrawalRequestForm,
      );
      if (response.data.status === 201) {
        window.alert("Withdrawal request deleted successfully");
        getWithdrawalRequests();
        getWithdrawalBalance();
      }
    } catch (e) {
      console.log(e);
    }
  }

  //  FUNCTIONS ========================================================================================================================

  function getTotalShareholdings() {
    if (dashboard.top_shareholdings.length > 0)
      return dashboard.top_shareholdings
        .reduce((a, b) => a + Number(b.portfolio_percent), 0)
        .toFixed(2);

    return 0;
  }

  // RENDER FUNCTIONS  ========================================================================================================================\

  function prepareTableRows() {
    return mmInterestLogs.map((item, index) => {
      return { ...item, no: index + 1, id: index };
    });
  }

  function loadingOverlay() {
    return (
      <GridOverlay>
        <div style={{ position: "absolute", top: 0, width: "100%" }}>
          <LinearProgress />
        </div>
      </GridOverlay>
    );
  }

  function renderNoRows() {
    return (
      <GridOverlay>
        <div>
          <h6 style={{ fontStyle: "italic" }}>No Transactions....</h6>
        </div>
      </GridOverlay>
    );
  }

  function renderNoRows2() {
    return (
      <GridOverlay>
        <div>
          <h6 style={{ fontStyle: "italic" }}>No Strategies....</h6>
        </div>
      </GridOverlay>
    );
  }

  function renderNoRowsWithdrawals() {
    return (
      <GridOverlay>
        <div>
          <h6 style={{ fontStyle: "italic" }}>No Withdrawal Requests....</h6>
        </div>
      </GridOverlay>
    );
  }

  function changePortfolio(t_id) {
    setPortfolio(t_id);
  }

  function invokeRefresh() {
    setLoading(true);
  }

  function handleOpenWithdrawModal() {
    setWithdrawAmount("");
    setWithdrawError("");
    setWithdrawModalOpen(true);
  }

  function handleCloseWithdrawModal() {
    setWithdrawModalOpen(false);
    setWithdrawAmount("");
    setWithdrawError("");
  }

  function handleWithdrawAmountChange(e) {
    const value = e.target.value;

    // Allow only a valid money format: digits with up to 2 decimal places.
    // Ignore the keystroke entirely if it would add a 3rd decimal.
    if (value !== "" && !/^\d*\.?\d{0,2}$/.test(value)) {
      return;
    }

    setWithdrawAmount(value);

    const numValue = parseFloat(value);
    if (isNaN(numValue) || numValue <= 0) {
      setWithdrawError("Please enter a valid amount greater than 0.");
    } else if (numValue > withdrawalBalance.cash_balance_raw) {
      setWithdrawError(
        `Amount exceeds available balance of RM ${withdrawalBalance.net_cash_balance}.`,
      );
    } else {
      setWithdrawError("");
    }
  }

  function handleSubmitWithdrawal() {
    // Round to 2 decimals to guard against paste/spinner extra precision
    const numValue = Math.round(parseFloat(withdrawAmount) * 100) / 100;
    if (
      isNaN(numValue) ||
      numValue <= 0 ||
      numValue > withdrawalBalance.cash_balance_raw
    ) {
      return;
    }
    // TODO: call API to submit withdrawal request
    submitWithdrawalRequest(numValue);
    handleCloseWithdrawModal();
  }

  function handleDeleteWithdrawalRequest(id) {
    let resp = window.confirm(
      "Are you sure to delete this withdrawal request?",
    );
    if (resp) {
      //call API to delete withdrawal request
      deleteWithdrawalRequest(id);
    }
  }

  function renderDATUpdateTooltip() {
    return (
      <Tooltip title='Updated hourly'>
        <ErrorOutlineIcon style={{ cursor: "pointer", fontSize: 27 }} />
      </Tooltip>
    );
  }

  return (
    <div>
      <Screen
        origin='savings'
        setPortfolio={changePortfolio}
        invokeRefresh={invokeRefresh}>
        <div style={{ textAlign: "center", fontSize: 30 }}>
          ET SavingsTracker
        </div>
        <br />
        <div className='row justify-content-center px-3'>
          {/* <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                <div className="aggStatBox">
                    <h3 className="boldText mb-3">Deposits</h3>
                    <h4 className="boldText text-center">RM {deposits}</h4>
                </div>
            </div> */}
          <div className='col-lg-4 col-md-4 col-sm-12 mb-4'>
            <div className='aggStatBox'>
              <h3 className='boldText mb-3'>
                Net Profit Earned&nbsp;
                <Tooltip
                  title={
                    <div>
                      Net Profit Earned = Total Profit Earned - (Accrued
                      Management Fees + Accrued Custodian Fees + Bank Charges)
                      <br />
                      <br />
                      You may experience a temporary drop in the Net Profit
                      Earned figure between 11:30 pm to 11:00 am the following
                      day due to daily accruals and profit earned calculations.
                      <br />
                      <br />
                      Daily accruals calculated - 11:30 pm daily.
                      <br />
                      <br />
                      Daily profit earned calculated - 11:00 am daily.
                    </div>
                  }>
                  <ErrorOutlineIcon
                    style={{ cursor: "pointer", fontSize: 27 }}
                  />
                </Tooltip>
              </h3>
              <h4
                className='boldText text-center'
                style={{
                  color:
                    parseFloat(String(mmInterest).replace(/,/g, "")) >= 0
                      ? "green"
                      : "red",
                }}>
                RM {mmInterest}
              </h4>
            </div>
          </div>
          <div className='col-lg-4 col-md-4 col-sm-12 mb-4'>
            <div className='aggStatBox'>
              <h3 className='boldText mb-3'>
                Net Cash Balance&nbsp;
                <Tooltip
                  title={
                    <div>
                      Net Cash Balance = Total Cash Balance + Total Profit
                      Earned - (Accrued Management Fees + Accrued Custodian Fees
                      + Bank Charges)
                      <br />
                      <br />
                      You may experience a temporary drop in the Net Cash
                      Balance figure between 11:30 pm to 11:00 am the following
                      day due to daily accruals and profit earned calculations.
                      <br />
                      <br />
                      Daily accruals calculated - 11:30 pm daily.
                      <br />
                      <br />
                      Daily profit earned calculated - 11:00 am daily.
                    </div>
                  }>
                  <ErrorOutlineIcon
                    style={{ cursor: "pointer", fontSize: 27 }}
                  />
                </Tooltip>
              </h3>
              <h4 className='boldText text-center'>RM {cashBalance}</h4>
            </div>
          </div>
          <div className='col-lg-4 col-md-4 col-sm-12 mb-4'>
            <div className='aggStatBox'>
              <h3 className='boldText mb-3'>
                Floating Balance&nbsp;
                <Tooltip title='Floating balance = Funds received but not yet approved. Approvals are processed Monday to Thursday 9:00 am - 5:00 pm.'>
                  <ErrorOutlineIcon
                    style={{ cursor: "pointer", fontSize: 27 }}
                  />
                </Tooltip>
              </h3>
              <h4 className='boldText text-center'>RM {floatingBalance}</h4>
            </div>
          </div>
          {/* <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                <div className="aggStatBox">
                    <h3 className="boldText mb-3">Withdrawals</h3>
                    <h4 className="boldText text-center">RM 0.00</h4>
                </div>
            </div> */}

          <div className='col-lg-6 col-md-6 col-sm-12 mb-3'>
            <div className='aggStatBox'>
              <h3 className='boldText mb-3'>Gross Profit Logs</h3>
              {/* <table>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Amount</th>
                      <th>Interest</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>2025-01-01</td>
                      <td>RM 100,000.00</td>
                      <td>RM 0.5</td>
                      <td>Interest</td>
                    </tr>
                    <tr>
                      <td>2025-01-02</td>
                      <td>RM 200.00</td>
                      <td>RM 10.00</td>
                      <td>Interest</td>
                    </tr>
                  </tbody>
                </table> */}

              <div
                style={{
                  flexGrow: 1,
                  backgroundColor: "white",
                  marginTop: 20,
                  height: 300,
                }}>
                <DataGridPro
                  density='compact'
                  // loading={isLoading}
                  columns={[
                    {
                      field: "reg_date",
                      headerName: "Date",
                      width: 150,
                      align: "center",
                      headerAlign: "center",
                      // flex: 1,
                    },
                    {
                      field: "amount",
                      headerName: "Amount",
                      // minWidth: 50,
                      flex: 1,
                      align: "center",
                      headerAlign: "center",
                    },
                  ]}
                  pagination
                  rows={prepareTableRows()}
                  components={{
                    // Toolbar: renderCustomToolbar,
                    LoadingOverlay: loadingOverlay,
                    NoRowsOverlay: renderNoRows,
                  }}
                />
              </div>
            </div>
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12 mb-3'>
            <div className='aggStatBox'>
              <h3 className='boldText mb-3'>Strategies</h3>
              {/* <table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Strategy Name</th>
                      <th>Client Code</th>
                      <th>Starting Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>Snowball</td>
                      <td>SW-A1-2510-10281-1</td>
                      <td>RM 50,000.00</td>
                      <td>Started</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Digital Assets Tracker</td>
                      <td>N/A</td>
                      <td>RM 100,000.00</td>
                      <td>Pending</td>
                    </tr>
                  </tbody>
                </table> */}

              <div
                style={{
                  flexGrow: 1,
                  backgroundColor: "white",
                  marginTop: 20,
                  height: 300,
                }}>
                <DataGridPro
                  density='compact'
                  // loading={isLoading}
                  columns={[
                    {
                      field: "strategy_label",
                      headerName: "Strategy Name",
                      flex: 1,
                      align: "center",
                      headerAlign: "center",
                    },
                    {
                      field: "strategy_client_code",
                      headerName: "Client Code",
                      minWidth: 50,
                      flex: 1,
                      align: "center",
                      headerAlign: "center",
                    },
                    {
                      field: "amount",
                      headerName: "Starting Amount",
                      minWidth: 50,
                      flex: 1,
                      align: "center",
                      headerAlign: "center",
                    },
                    {
                      field: "strategy_distributed",
                      headerName: "Status",
                      minWidth: 50,
                      flex: 1,
                      align: "center",
                      headerAlign: "center",
                    },
                  ]}
                  pagination
                  rows={strategies}
                  components={{
                    // Toolbar: renderCustomToolbar,
                    LoadingOverlay: loadingOverlay,
                    NoRowsOverlay: renderNoRows2,
                  }}
                />
              </div>
            </div>
          </div>
          <div className='col-lg-12 col-md-12 col-sm-12 mb-3'>
            <div className='aggStatBox'>
              <div style={{ display: "flex", alignItems: "center" }}>
                <h3 className='boldText mb-3'>Withdrawal Requests</h3>
                {withdrawalBalance.cash_balance_raw > 0 &&
                  !withdrawalRequests.some((r) =>
                    [
                      "pending",
                      "executing",
                      "pending_management_1",
                      "pending_management_2",
                    ].includes(r.req_status),
                  ) && (
                    <button
                      className='btn btn-danger ml-3'
                      style={{ marginBottom: 12 }}
                      onClick={handleOpenWithdrawModal}>
                      Create Withdrawal Request
                    </button>
                  )}
              </div>

              <div
                style={{
                  flexGrow: 1,
                  backgroundColor: "white",
                  marginTop: 20,
                  height: 300,
                }}>
                <DataGridPro
                  density='compact'
                  columns={[
                    {
                      field: "no",
                      headerName: "No.",
                      width: 80,
                      align: "center",
                      headerAlign: "center",
                    },
                    {
                      field: "reg_date",
                      headerName: "Date Requested",
                      width: 150,
                      align: "center",
                      headerAlign: "center",
                    },
                    {
                      field: "amount",
                      headerName: "Withdrawal Amount",
                      flex: 1,
                      align: "center",
                      headerAlign: "center",
                    },
                    {
                      field: "req_status",
                      headerName: "Status",
                      flex: 1,
                      align: "center",
                      headerAlign: "center",
                      valueFormatter: (params) => {
                        if (params.value === "pending") {
                          return "Pending";
                        } else if (
                          params.value === "pending_management_1" ||
                          params.value === "pending_management_2"
                        ) {
                          return "Pending Approval";
                        } else if (params.value === "executing") {
                          return "Processing";
                        } else if (params.value === "executed") {
                          return "Withdrawal Completed";
                        } else if (params.value === "failed") {
                          return "Rejected / Failed";
                        }
                      },
                    },
                    {
                      field: "action",
                      headerName: "Action",
                      flex: 1,
                      align: "center",
                      headerAlign: "center",
                      renderCell: (params) => {
                        if (
                          params.row.req_status === "pending" &&
                          params.row.initiator === "client"
                        ) {
                          return (
                            <Button
                              color='warning'
                              size='small'
                              variant='outlined'
                              style={{ fontSize: 10 }}
                              onClick={() => {
                                handleDeleteWithdrawalRequest(params.row.id);
                              }}>
                              Cancel Request
                            </Button>
                          );
                        } else {
                          return <span>-</span>;
                        }
                      },
                    },
                  ]}
                  pagination
                  rows={withdrawalRequests}
                  components={{
                    LoadingOverlay: loadingOverlay,
                    NoRowsOverlay: renderNoRowsWithdrawals,
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Withdrawal Request Modal */}
        <Dialog
          open={withdrawModalOpen}
          onClose={handleCloseWithdrawModal}
          maxWidth='sm'
          fullWidth>
          <DialogTitle>Create Withdrawal Request</DialogTitle>
          <DialogContent>
            {withdrawalBalance.is_corporate ? (
              <div style={{ marginTop: 8 }}>
                <p
                  style={{
                    fontSize: 14,
                    color: "#666",
                    marginBottom: 16,
                    textAlign: "center",
                  }}>
                  Corporate accounts must submit a withdrawal request via email.
                </p>
                <div style={{ textAlign: "center", marginBottom: 20 }}>
                  <a
                    href={withdrawalForm}
                    download="Template - Savings Tracker Withdrawal Email.pdf"
                    className='btn btn-primary'>
                    Download Withdrawal Form
                  </a>
                </div>
                <div
                  style={{
                    backgroundColor: "#fff8f8",
                    border: "1px solid #f5c2c2",
                    borderRadius: 6,
                    padding: "12px 16px",
                    marginBottom: 16,
                  }}>
                  <p
                    style={{
                      fontSize: 13,
                      color: "#c0392b",
                      fontWeight: 600,
                      margin: "0 0 8px 0",
                    }}>
                    IMPORTANT: This withdrawal request must be submitted before
                    10:00 AM on a business day. The withdrawn funds will be
                    received on the subsequent business day.
                  </p>
                  <p style={{ fontSize: 13, color: "#c0392b", margin: 0 }}>
                    Should you have any inquiries, please contact your
                    designated Marketing Representative (MR) or email{" "}
                    <a
                      href='mailto:etsw.support@equitiestracker.com'
                      style={{ color: "#c0392b" }}>
                      etsw.support@equitiestracker.com
                    </a>
                    .
                  </p>
                </div>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: 13,
                  }}>
                  <tbody>
                    {(() => {
                      const mr = withdrawalBalance.market_rep?.[0];
                      const ccEmails = [mr?.mr_email, mr?.mr_email_2]
                        .filter(Boolean)
                        .join(", ");
                      return [
                        {
                          label: "To",
                          value: "etsw.support@equitiestracker.com",
                        },
                        {
                          label: "Cc",
                          value: ccEmails || "etsw.support@equitiestracker.com",
                        },
                        {
                          label: "Subject",
                          value: "WITHDRAWAL FROM SAVINGS TRACKER PORTFOLIO",
                        },
                      ];
                    })().map(({ label, value }) => (
                      <tr
                        key={label}
                        style={{ borderTop: "1px solid #e0e0e0" }}>
                        <td
                          style={{
                            padding: "8px 12px",
                            fontWeight: 700,
                            width: 70,
                            color: "#333",
                            verticalAlign: "top",
                          }}>
                          {label}
                        </td>
                        <td style={{ padding: "8px 12px", color: "#444" }}>
                          {value}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <>
                <div style={{ marginBottom: 16, marginTop: 8 }}>
                  <span style={{ fontSize: 14, color: "#666" }}>
                    Available balance for withdrawal:{" "}
                    <strong
                      style={{
                        color: "#1976d2",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={() => {
                        setWithdrawAmount(
                          withdrawalBalance.cash_balance_raw.toFixed(2),
                        );
                        setWithdrawError("");
                      }}>
                      RM {withdrawalBalance.net_cash_balance}
                    </strong>
                  </span>
                </div>
                <TextField
                  autoFocus
                  label='Amount to Withdraw (RM)'
                  type='number'
                  fullWidth
                  variant='outlined'
                  value={withdrawAmount}
                  onChange={handleWithdrawAmountChange}
                  error={!!withdrawError}
                  helperText={withdrawError}
                  inputProps={{
                    min: 0,
                    max: withdrawalBalance.cash_balance_raw,
                    step: "0.01",
                  }}
                />
                {withdrawalBalance.bank_accounts[0] ? (
                  (() => {
                    const acct = withdrawalBalance.bank_accounts[0];
                    const digits = acct.account_number.replace(/\s/g, "");
                    const masked = "•••• " + digits.slice(-4);
                    const now = new Date();
                    const cutoffHour = 10;
                    const isBeforeCutoff = now.getHours() < cutoffHour;
                    const expectedArrival = isBeforeCutoff
                      ? "same day (T) or next business day (T+1)"
                      : "next business day (T+1)";
                    const tooltipText = `Withdrawal requests submitted before 10:00 AM are processed same day — funds typically arrive ${expectedArrival}. Requests submitted at or after 10:00 AM will arrive the next business day.`;
                    return (
                      <>
                        <div
                          style={{
                            marginTop: 12,
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}>
                          <span style={{ fontSize: 13, color: "#666" }}>
                            Withdrawal to:
                          </span>
                          <span style={{ fontSize: 13, fontWeight: 600 }}>
                            {acct.bank_name}
                          </span>
                          <span
                            style={{
                              fontSize: 13,
                              color: "#444",
                              letterSpacing: 1,
                            }}>
                            {masked}
                          </span>
                          <Tooltip title="If your bank account details are incorrect, please contact your Market Representative to update them." placement="right" arrow>
                            <InfoIcon style={{ fontSize: 16, color: "#1976d2", cursor: "pointer" }} />
                          </Tooltip>
                        </div>
                        <div style={{ marginTop: 10 }}>
                          <span style={{ fontSize: 12, color: "#666" }}>
                            Expected arrival: <strong>{expectedArrival}</strong>
                          </span>
                          <div style={{ fontSize: 11, color: "#888", marginTop: 4 }}>
                            {tooltipText}
                          </div>
                        </div>
                      </>
                    );
                  })()
                ) : (
                  <div
                    style={{ marginTop: 12, fontSize: 13, color: "#d32f2f" }}>
                    No bank account found. Please contact your Market
                    Representative to update your bank details before making a
                    withdrawal.
                  </div>
                )}
              </>
            )}
          </DialogContent>
          <DialogActions style={{ padding: "16px 24px" }}>
            <button
              className='btn btn-secondary'
              onClick={handleCloseWithdrawModal}>
              Cancel
            </button>
            {!withdrawalBalance.is_corporate && (
              <button
                className='btn btn-danger'
                onClick={handleSubmitWithdrawal}
                disabled={
                  !withdrawAmount ||
                  !!withdrawError ||
                  !withdrawalBalance.bank_accounts[0]
                }>
                Submit Withdrawal Request
              </button>
            )}
          </DialogActions>
        </Dialog>
      </Screen>
    </div>
  );
}

export default SavingsPage;
